import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2f80ef61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tree-container" }
const _hoisted_2 = { class: "tree-title" }
const _hoisted_3 = {
  key: 0,
  class: "notify-desc"
}
const _hoisted_4 = { class: "tree-box el-card" }
const _hoisted_5 = { class: "custom-tree-node" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "father-name" }
const _hoisted_8 = { class: "item-name" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "father-name title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tree = _resolveComponent("el-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.HandleTypeTxtMap[_ctx.repairType]) + "(", 1),
      _createVNode(_component_el_button, { type: "text" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.SUB_IDS.length), 1)
        ]),
        _: 1
      }),
      _createTextVNode(")" + _toDisplayString(_ctx.$t('safeProtectionModule.itemsUnit')) + " ", 1),
      (_ctx.repairType===_ctx.HandleType.NOTIFY)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('safeProtectionModule.baselineNotifyPartial')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createVNode(_component_el_tree, {
          data: _ctx.TREE_ITEM,
          "node-key": "id",
          props: _ctx.defaultProps,
          "default-expanded-keys": _ctx.TREE_EXPAND_KEYS,
          "check-on-click-node": ""
        }, {
          default: _withCtx(({ node, data }) => [
            _createElementVNode("div", _hoisted_5, [
              (data.fatherName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(data.fatherName), 1),
                    _createElementVNode("span", _hoisted_8, "- " + _toDisplayString(node.label), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("span", {
                      class: _normalizeClass(`icon${data.id}`)
                    }, null, 2),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(node.label), 1)
                  ])),
              _createElementVNode("div", null, [
                (!data.items)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      size: "mini",
                      "model-value": _ctx.repairType,
                      placeholder: _ctx.$t('safeProtectionModule.pleaseSelect'),
                      "default-first-option": true,
                      onChange: ($event: any) => (_ctx.changeHandleType($event, _ctx.repairType, data))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value,
                            disabled: item.value === 1 && _ctx.isSelfItem(data.id)
                          }, null, 8, ["label", "value", "disabled"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["model-value", "placeholder", "onChange"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["data", "props", "default-expanded-keys"])
      ])
    ])
  ]))
}